import { myApi } from '../../config/axiosConfig';

// =========================================
// FETCH ACTIVE EVENTS
// =========================================

export const getActiveEvents = async () => {

    try {

        const { data } = await myApi.get('/safety/hos/active');

        return data;

    } catch (error) {

        console.log(error);

    }

}

// =========================================
// FETCH CLOSED EVENTS
// =========================================

export const getClosedEvents = async () => {

    try {

        const { data } = await myApi.get('/safety/hos/closed');

        return data;

    } catch (error) {

        console.log(error);

    }

}